import * as React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { getAuth } from "firebase/auth";

const auth = getAuth();

const root = ReactDOM.createRoot(document.getElementById("root"));

auth.onAuthStateChanged((user) => {
    root.render(
        <React.StrictMode>
            <App isLoggedIn={!!user} />
        </React.StrictMode>,
    );
});

root.render(
    <React.StrictMode>
        <App isLoggedIn={!!auth.currentUser} />
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
